export default class {
  constructor($uibModalInstance, amOperatorsService, operator) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.opService = amOperatorsService;
    this.operator = operator;
    this.status = '';
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
  //on delete successfully just close the popup
  deleteOperator() {
    if (!this.operator) return;
    this.status = 'deleting';
    this.opService
      .deleteOperator(this.operator.id)
      .then(() => {
        this.$uibModalInstance.close();
      })
      .catch(() => {
        this.status = 'error';
      });
  }
}
